import { INVALID_ARGUMENT as r } from "@liff/consts";
import { createLiffError as e } from "@liff/util";
import { fetch as t, getEndPoint as n } from "@liff/server-api";

var o = function o(r) {
  return "object" == typeof r && null !== r && function (r) {
    return "string" == typeof r || r instanceof String;
  }(r.type);
};

function i(t) {
  return Promise.reject(e(r, t));
}

function f(r) {
  if (!function (r) {
    return Array.isArray(r) && r.every(o);
  }(r)) return i("Parameter 'messages' must be an array of { type, ... }");
  var e = r.length;
  return e < 1 || e > 5 ? i("Number of messages should be in range 1 to 5.") : t(n("message"), {
    method: "POST",
    body: JSON.stringify({
      messages: r
    })
  });
}

export { f as sendMessages };